<template>
    <v-layout>
        <v-dialog v-model="isShowDialog" max-width="35rem">
            <v-card>
                <v-card-title class="secondary elevation-4 white--text">
                    <div class="text-h5">
                        <v-icon class="pb-1" color="white" medium> fa-external-link-alt </v-icon>
                        {{ dialogHeader }}
                    </div>
                </v-card-title>
                <v-card-text class="message pa-4">
                    {{ $t('Your_entry_has_not_been_saved') }}<br />
                    {{ dialogMessage }}
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <button-app-control ref="cancel-btn" :label="$t('Cancel')" text @click="closeDialog" />
                    <button-app-control ref="move-btn" :label="$t('Move')" @click="confirmMove" />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ButtonAppControl } from '../../atoms';

@Component({
    name: 'TheConfirmDialog',
    components: {
        ButtonAppControl,
    },
})
export default class TheConfirmDialog extends Vue {
    @Prop({ default: false }) isShow: boolean;
    @Prop({ default: '' }) dialogMessage: string;
    @Prop({ default: '' }) dialogHeader: string;

    /**
     * getter, setter
     */
    get isShowDialog(): boolean {
        return this.isShow;
    }
    set isShowDialog(newVal: boolean) {
        this.closeDialog();
    }

    /**
     * methods
     */
    closeDialog(): void {
        this.$emit('cancel-dialog');
    }
    confirmMove(): void {
        this.$emit('move');
    }
}
</script>

<style lang="scss">
.message {
    word-break: break-all;
}
</style>
